<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('questionnaires.manage-questionnaires-title') }}</h1>
				</div>
				<div class="col-auto">
					<div class="page-utilities">
						<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
							<div class="col-auto">
								<a class="btn app-btn-secondary" data-bs-toggle="modal" data-bs-target="#createQuestionnaireModal" href="#">
									<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
									</svg>
									{{ __('questionnaires.add') }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<div v-if="questionnaires.length > 0" class="app-card app-card-orders-table shadow-sm mb-5">
						<div class="app-card-body">
							<div class="table-responsive">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
									<tr>
										<th class="cell">{{ __('questionnaires.name') }}</th>
										<th class="cell">{{ __('questionnaires.status') }}</th>
										<th class="cell">{{ __('questionnaires.last-modified') }}</th>
                                        <th class="cell">{{ __('questionnaires.actions') }}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="questionnaire in questionnaires" :key="questionnaire.id">
										<td class="cell">{{ questionnaire.name }}</td>
										<td class="cell">
											<span class="badge" :class="questionnaire.is_active ? 'bg-success' : 'bg-secondary'">{{ questionnaire.is_active ? __('questionnaires.published-true') : __('questionnaires.published-false') }}</span>
										</td>
                                        <td class="cell">{{ moment(questionnaire.updated_at).format("DD-MM-YYYY / HH:mm") }}</td>
										<td class="cell">
											<a class="btn app-btn-secondary" :href="'questionnaires/' + questionnaire.id + '/edit '">{{  __('actions.edit')  }}</a>
                                            <a class="btn app-btn-secondary" href="#" @click.prevent="cloneQuestionnaire(questionnaire)">{{  __('actions.duplicate')  }}</a>
											<a v-if="!questionnaire.is_active" class="btn app-btn-danger" href="#" @click.prevent="deleteQuestionnaire(questionnaire)">{{  __('actions.delete')  }}</a>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div v-else class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
						<div class="inner">
							<div class="app-card-body p-3 p-lg-4">
								<h3 class="mb-3">{{ __('questionnaires.no-questionnaires-title') }}</h3>
								<p>{{ __('questionnaires.no-questionnaires-text') }}</p>
								<a class="btn app-btn-primary" href="#" data-bs-toggle="modal" data-bs-target="#createQuestionnaireModal">
									<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
									</svg>{{ __('questionnaires.add') }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
		<new-questionnaire-modal></new-questionnaire-modal>
	</div>
</template>

<script>
export default {
	props: {
		questionnairesProp: {
			type: Array,
			required: true,
		}
	},

	data() {
		return {
			questionnaires: this.questionnairesProp,
            moment: moment
		}
	},

	methods: {
        getQuestionnaires: function (){
            axios.get(`/get-questionnaires`)
                .then(response => {
                    this.questionnaires = response.data.questionnaires
                })
        },

        cloneQuestionnaire: function (questionnaire) {
            axios.post(`/questionnaires/${questionnaire.id}/clone`).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                this.getQuestionnaires()
            }).catch(error => {
	            Toast.fire({icon: 'error', title: error.response.data.message})
                this.errors = error.response.data.errors
            })
        },

        deleteQuestionnaire: function (questionnaire) {
            Swal.fire({
                title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes'),
                cancelButtonText:  this.__('actions.confirm-no'),
                showLoaderOnConfirm: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
                preConfirm: login => {
                    return axios.delete(`/questionnaires/${questionnaire.id}`).then(response => {
                        return response.data
                    })
                        .catch(error => {
                            Swal.showValidationMessage(`Something went Wrong!: ${error}`)
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                if (result.value) {
                    Toast.fire({icon: 'success', title: result.value.message})
                    this.getQuestionnaires()
                }
            })
        }
	}
}
</script>
